import React, { useState, useEffect } from 'react';

const C = {
  primary: '#0F6E56',
  primaryBg: '#E1F5EE',
  border: '#E3E1D9',
  text: '#1F1E1B',
  muted: '#5F5E5A',
  surface: '#F7F5F0',
};

/**
 * Asli flag image. Emoji flags bohat se Android aur Windows par
 * render hi nahi hote, is liye flagcdn ki chhoti PNG use ki hai.
 * Image na chale to code (PK, NG) dikha deta hai - kabhi khaali nahi.
 */
function Flag({ code, size = 16 }) {
  const [bad, setBad] = useState(false);
  if (!code || code.length !== 2) return <span>{'\u{1F30D}'}</span>;
  if (bad) {
    return (
      <span style={{ fontSize: 10, fontWeight: 700, color: C.muted, letterSpacing: 0.5 }}>
        {code.toUpperCase()}
      </span>
    );
  }
  return (
    <img
      src={`https://flagcdn.com/w40/${code.toLowerCase()}.png`}
      alt={code}
      width={size}
      height={Math.round(size * 0.75)}
      loading="lazy"
      onError={() => setBad(true)}
      style={{ borderRadius: 2, verticalAlign: 'middle', objectFit: 'cover' }}
    />
  );
}

export default function CommunityFooter() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = () => {
      fetch('/api/community-stats/')
        .then((r) => r.json())
        .then((d) => { if (alive) setData(d); })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 60000); // har minute refresh
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!data || data.error) return null;

  const countries = data.countries || [];
  const recent = (data.recent_joins || []).slice(0, 8);

  return (
    <div style={{ borderTop: `1px solid ${C.border}`, background: C.surface, marginTop: 24, padding: '14px 16px 22px' }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>

        {recent.length > 0 && (
          <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', marginBottom: 12, borderBottom: `1px solid ${C.border}`, paddingBottom: 10 }}>
            <div className="footerTicker" style={{ display: 'inline-block', paddingLeft: '100%', animation: 'footer-marquee 45s linear infinite', fontSize: 11.5, color: C.muted }}>
              {recent.concat(recent).map((r, i) => (
                <span key={i} style={{ marginRight: 26 }}>
                  {r.country_code && <Flag code={r.country_code} size={13} />}
                  {' '}<b style={{ color: C.text }}>@{r.username}</b>
                  {r.country_name ? ` from ${r.country_name}` : ''}
                  {r.joined_ago ? ` \u00b7 joined ${r.joined_ago}` : ''}
                </span>
              ))}
            </div>
            <style>{`@keyframes footer-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
          </div>
        )}

        {/* ---- summary line ---- */}
        <div
          onClick={() => setOpen(!open)}
          style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', flexWrap: 'wrap' }}
        >
          <span style={{ fontSize: 20 }}>🌍</span>
          <span style={{ fontSize: 13, color: C.text, fontWeight: 600 }}>
            {data.country_count} {data.country_count === 1 ? 'country' : 'countries'}
          </span>
          <span style={{ color: C.border }}>·</span>
          <span style={{ fontSize: 13, color: C.text }}>
            {data.total_members} members
          </span>
          <span style={{ color: C.border }}>·</span>
          <span style={{ fontSize: 13, color: C.primary, fontWeight: 600 }}>
            <span style={{
              display: 'inline-block', width: 7, height: 7, borderRadius: 4,
              background: data.online_now > 0 ? '#2ECC71' : '#B4B2A9', marginRight: 5,
            }} />
            {data.online_now} online
          </span>
          <span style={{ marginLeft: 'auto', fontSize: 11, color: C.muted }}>
            {open ? '▲ hide' : '▼ view'}
          </span>
        </div>

        {/* ---- flags strip (hamesha nazar) ---- */}
        {countries.length > 0 && (
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 10 }}>
            {countries.slice(0, open ? countries.length : 12).map((c) => (
              <span
                key={c.code}
                title={`${c.name} — ${c.joined} joined, ${c.online} online`}
                style={{
                  fontSize: 12, background: '#fff', border: `0.5px solid ${C.border}`,
                  borderRadius: 14, padding: '3px 9px', color: C.text, whiteSpace: 'nowrap',
                }}
              >
                <Flag code={c.code} size={15} /> {c.joined}
                {c.online > 0 && (
                  <span style={{ color: '#2ECC71', fontWeight: 600 }}> ·{c.online}</span>
                )}
              </span>
            ))}
          </div>
        )}

        {/* ---- khula hua hissa ---- */}
        {open && (
          <div style={{ marginTop: 14 }}>
            <p style={{ fontSize: 12, fontWeight: 600, margin: '0 0 6px', color: C.text }}>
              Where our members are
            </p>
            {countries.map((c) => (
              <div key={c.code} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0', borderBottom: `1px solid #F1EFE8` }}>
                <span style={{ fontSize: 13, color: C.text, display: 'flex', alignItems: 'center', gap: 6 }}>
                  <Flag code={c.code} size={18} /> {c.name}
                </span>
                <span style={{ fontSize: 12, color: C.muted }}>
                  {c.joined} joined
                  {c.online > 0 && <span style={{ color: '#2ECC71', fontWeight: 600 }}> · {c.online} online</span>}
                </span>
              </div>
            ))}
            {data.unknown_country > 0 && (
              <p style={{ fontSize: 11, color: C.muted, margin: '6px 0 0' }}>
                {data.unknown_country} member{data.unknown_country === 1 ? '' : 's'} not located yet
              </p>
            )}

            {recent.length > 0 && (
              <>
                <p style={{ fontSize: 12, fontWeight: 600, margin: '14px 0 6px', color: C.text }}>
                  Newest members
                </p>
                {recent.map((r) => (
                  <div key={r.username} style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
                    <span style={{ fontSize: 12, color: C.text }}>
                      <Flag code={r.country_code} size={14} /> @{r.username}
                      {r.is_online && <span style={{ color: '#2ECC71', fontSize: 10 }}> ● online</span>}
                    </span>
                    <span style={{ fontSize: 11, color: C.muted }}>{r.joined_ago}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}

        <p style={{ fontSize: 10, color: C.muted, margin: '14px 0 0', textAlign: 'center' }}>
          PenFlow · XpertCreation · powered by Pi Network
        </p>
      </div>
    </div>
  );
}
